import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core'
import { CommonModule, DatePipe, AsyncPipe } from '@angular/common'
import { SmsMessage } from '../../../models/smsMessage'
import { Workgroup } from '../../../models/workgroup'
import { IonicModule, AlertController, IonInfiniteScroll, IonSelect } from '@ionic/angular'
import { UsersService } from '../../../services/domain/users.service'
import { first, map, tap } from 'rxjs/operators'
import { Observable } from 'rxjs'
import { FeathersHealthCheckService } from '../../../services/feathersHealthCheck/feathers-health-check.service'
import { NgxFloatUiModule, NgxFloatUiContentComponent, NgxFloatUiTriggers } from 'ngx-float-ui'
import { StripTagsPipe } from '../../../shared/pipes/stripHtml.pipe'

type ActiveTab = 'inbound' | 'outbound'

@Component({
  selector: 'app-sms-messages-list',
  standalone: true,
  imports: [CommonModule, IonicModule, NgxFloatUiModule, DatePipe, AsyncPipe, StripTagsPipe],
  templateUrl: './sms-messages-list.component.html',
  styleUrls: ['./sms-messages-list.component.scss'],
})
export class SmsMessagesListComponent implements OnInit, OnChanges {
  private alertController = inject(AlertController)
  private userService = inject(UsersService)
  private healthCheckService = inject(FeathersHealthCheckService)

  // @Input() messages: SmsMessage[]

  @Input() inboundMessages$: Observable<SmsMessage[]>
  @Input() outboundMessages$: Observable<SmsMessage[]>
  @Input() workgroups: Workgroup[]

  @Output() workgroupFilterChanged = new EventEmitter<Workgroup>()
  @Output() loadInboundSmsFromOffset = new EventEmitter<number>()
  @Output() loadOutboundSmsFromOffset = new EventEmitter<number>()
  @Output() messageRead = new EventEmitter<SmsMessage>()
  @Output() markAllMessagesRead = new EventEmitter<void>()

  @ViewChild('inboundInfiniteScroll') inboundInfiniteScroll: IonInfiniteScroll
  @ViewChild('outboundInfiniteScroll') outboundInfiniteScroll: IonInfiniteScroll
  @ViewChild('workgroupFilterSelect') wgSelect: IonSelect
  @ViewChild('markAllAsReadPopper') markAllAsReadPopper: NgxFloatUiContentComponent

  smsHubConnected$: Observable<boolean>

  // sortedInboundMessages: SmsMessage[]
  sortedInboundMessages$: Observable<SmsMessage[]>
  sortedOutboundMessages$: Observable<SmsMessage[]>

  private inboundMessagesLoadedLength: number = 0
  private outboundMessagesLoadedLength: number = 0

  defaultWorkgroupValue: any
  compareWithFn = (o1, o2) => {
    return o1 && o2 ? o1.id === o2.id : o1 === o2
  }

  activeTab: ActiveTab = 'inbound'

  protected readonly NgxFloatUiTriggers = NgxFloatUiTriggers

  constructor() {
    this.smsHubConnected$ = this.healthCheckService.checkSmsHubHealth()
  }

  ngOnInit() {
    this.sortedInboundMessages$ = this.inboundMessages$.pipe(
      tap((e) => console.log('new inbound msg', e)),
      map((msgs) => {
        this.inboundMessagesLoadedLength = msgs.length
        return msgs.sort(this.sortByCreatedAt)
      }),
      tap((_) => this.inboundInfiniteScroll.complete()),
    )
    this.sortedOutboundMessages$ = this.outboundMessages$.pipe(
      tap((e) => console.log('new outbound msg', e)),
      map((msgs) => {
        this.outboundMessagesLoadedLength = msgs.length
        return msgs.sort(this.sortByCreatedAt)
      }),
      tap((_) => this.outboundInfiniteScroll.complete()),
    )

    this.loadMoreInboundData()
    this.loadMoreOutboundData()
  }

  sortByCreatedAt = (a, b) => {
    if (a.createdAt < b.createdAt) return 1
    if (a.createdAt > b.createdAt) return -1
    return 0
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes)
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          // case 'messages':
          //   if (!this.messages) break
          //   this.sortedInboundMessages = this.messages.sort((a, b) => {
          //     if (a.createdAt < b.createdAt) return 1
          //     if (a.createdAt > b.createdAt) return -1
          //     return 0
          //   } )
          //   this.inboundInfiniteScroll.complete()
          //   break
          case 'workgroups':
            this.userService
              .getCurrentUserWorkgroup()
              .pipe(first())
              .toPromise()
              .then((wg) => {
                console.log('sms select got wg', wg)
                this.defaultWorkgroupValue = wg
              })
        }
      }
    }
  }

  workgroupIdFilterSelectChanged($event: any) {
    const wg: Workgroup = $event.target.value
    this.workgroupFilterChanged.emit(wg)
  }

  async openMessage(msg: SmsMessage) {
    const fromAndContent = `Od: ${msg.getName()}<br>${msg.body}`

    const alert = await this.alertController.create({
      cssClass: 'privateMessageAlert',
      header: msg.getName(),
      message: fromAndContent,
      buttons: [
        {
          text: 'Zpět',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Zpět', blah)
          },
        },
        {
          text: 'Odpovědět',
          handler: () => {
            console.log('Odpovědět')
            // this.replyToMessage.emit(msg)
          },
        },
      ],
    })

    await alert.present()
    this.markMessageRead(msg)
  }

  loadMoreInboundData() {
    console.log('loading more inbound sms...')
    this.loadInboundSmsFromOffset.emit(this.inboundMessagesLoadedLength)
  }

  loadMoreOutboundData() {
    console.log('loading more outbound sms...')
    this.loadOutboundSmsFromOffset.emit(this.outboundMessagesLoadedLength)
  }

  private markMessageRead(msg: SmsMessage) {
    this.messageRead.emit(msg)
  }

  markAllAsRead() {
    this.markAllMessagesRead.emit()
  }

  activeTabChange(event: CustomEvent) {
    this.activeTab = event.detail.value
  }
}
